import React from 'react';
import { Route } from 'react-router';
import PublicForms from '../../components/Pages/Forms/PublicForms';


const routes = <Route path="public-forms" component={PublicForms.LandingPage} />;

export default routes;



// WEBPACK FOOTER //
// ./src/routes/www/publicForms.js